import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    'sub-layer-checkbox': true,
    'sub-layer-checkbox--checked': _ctx.checked,
  })
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}